import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Switch, BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { AnimatedSwitch } from "react-router-transition";
import { Capacitor } from "@capacitor/core";
import { Toast } from "@capacitor/toast";
import { userRoutes, authRoutes } from "./routes/allRoutes";
import Authmiddleware from "./routes/middleware/Authmiddleware";
import Amplify from "aws-amplify";
import awsconfig from "./aws-exports";
import HorizontalLayout from "./components/HorizontalLayout/";
import { Session } from "@talkjs/react";
import Cookies from "js-cookie";
import "./assets/scss/theme.scss";
import { Preferences } from "@capacitor/preferences";

Amplify.configure(awsconfig);

const App = (props) => {
  const [userId, setUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  function getLayout() {
    let layoutCls = HorizontalLayout;
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = HorizontalLayout;
        break;
    }
    return layoutCls;
  }

  useEffect(() => {
    const fetchContactDetail = async () => {
      try {
        const contactDetail = Capacitor.isNativePlatform()
          ? await Preferences.get({ key: "ContactDetail" }).then(
              ({ value }) => value
            )
          : Cookies.get("ContactDetail");

        console.log("Retrieved contact detail:", contactDetail);

        if (contactDetail) {
          const parsedContact = JSON.parse(contactDetail);
          if (parsedContact.talkJsId) {
            setUserId(parsedContact.talkJsId);
          }
        }
      } catch (error) {
        console.error("Error accessing cookie:", error);
      } finally {
        setIsLoading(false);
      }
    };

    // Call the async function
    fetchContactDetail();
  }, []);

  const Layout = getLayout();

  // Loading state handler
  if (isLoading) {
    return <></>;
  }

  // Router content that will be wrapped in Session if userId exists
  const RouterContent = () => (
    <>
      {Capacitor.isNativePlatform() === "not-true" ? (
        <AnimatedSwitch
          atEnter={{ translateX: 100 }}
          atLeave={{ translateX: -100 }}
          atActive={{ translateX: 0 }}
          mapStyles={(styles) => ({
            transform: `translateX(${styles.translateX}%)`,
          })}
          className="switch-wrapper"
        >
          {authRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
            />
          ))}
        </AnimatedSwitch>
      ) : (
        <Switch>
          {authRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
            />
          ))}
        </Switch>
      )}
    </>
  );

  return (
    <React.Fragment>
      <Router>
        {userId ? (
          <Session appId={process.env.REACT_APP_TALKJS_APP_ID} userId={userId}>
            <RouterContent />
          </Session>
        ) : (
          // Render routes without TalkJS Session when no userId
          <RouterContent />
        )}
      </Router>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
